import React, { lazy } from "react";
import { useParams } from "react-router-dom";
import RequireAuth from "./RequireAuth";
import lazyLoad from "./lazyLoad";
import { PERMISSIONS } from "../utils/Permissions";
import { getFlag } from "../v2/core/flags";
import { useV2Toggle } from "../context/experienceToggleContext";

const MerchantList = lazyLoad(lazy(() => import("../Pages/Merchants/List")));
const UserListV2 = lazyLoad(lazy(() => import("../v2/pages/User/UserListV2")));

const getPermission = (usertype) => {
  const map = {
    individual: PERMISSIONS.MERCHANT_INDIVIDUAL_MERCHANT,
    business: PERMISSIONS.MERCHANT_BUSINESS_MERCHANT,
    ncmc_user: PERMISSIONS.MERCHANT_NCMC_USER,
  };
  return map[usertype] || "UNKNOWN";
};

const MerchantAuthWrapper = () => {
  const { usertype } = useParams();
  const requiredPermission = getPermission(usertype);
  const { preferV2 } = useV2Toggle();
  const useV2 = getFlag("USE_V2_USER") && !!preferV2;

  return (
    <RequireAuth requiredPermission={requiredPermission} useV2Layout={useV2}>
      {useV2 ? <UserListV2 mode={usertype} /> : <MerchantList />}
    </RequireAuth>
  );
};

export default MerchantAuthWrapper;
